import { firestore } from "../../firebase/firebase";
import { AppThunk } from "../../models/app-thunk";
import * as types from "../../constants";
import { CF_URL } from "../../constants/api";
import { ObservacionChecklist } from "../../models/ObservacionChecklist";
import firebase from "firebase/app";
import "firebase/firestore";
import Axios from "axios";
import { format } from "date-fns";

export const getObservations = (
	projectId: string
): AppThunk => {
	return async (dispatch) => {
		dispatch({
			type: types.OBSERVATIONS_CHECKLIST_LOADING,
		});
		try {
			const snaps = await firestore
				.collection("RespuestasErrorestipos")
				.where("ProyectoId", "==", projectId)
				.orderBy("FechaCreacion", "desc")
				.get();

			let actualErrorTipo: string | null = null;
			let actualErrorTipoCount = 1;
			const observations = snaps.docs
				.map(
					(doc) =>
						({
							...(doc.data() as any),
							id: doc.id,
						} as ObservacionChecklist)
				)
				.sort((a, b) => {
					return (
						// b.FechaCreacion.toMillis() - a.FechaCreacion.toMillis() ||
						a.NombreListado.localeCompare(
							b.NombreListado
						) ||
						a?.NombreRevision?.localeCompare(
							b.NombreRevision
						) ||
						a.NombreRecinto.localeCompare(
							b.NombreRecinto
						) ||
						a.NombreSubcontrato.localeCompare(
							b.NombreSubcontrato
						) ||
						a.NombreErrorTipo.localeCompare(
							b.NombreErrorTipo
						)
					);
				})
				.map((obs, _, arr) => {
					if (obs.ErrorTipoId !== actualErrorTipo) {
						actualErrorTipoCount = arr.filter(
							(o) => o.ErrorTipoId === obs.ErrorTipoId
						).length;
						actualErrorTipo = obs.ErrorTipoId;
					}
					obs.Order = actualErrorTipoCount;
					actualErrorTipoCount -= 1;
					return obs;
				});

			dispatch({
				type: types.OBSERVATIONS_CHECKLIST_SUCCESS,
				payload: observations,
			});
		} catch (error: any) {
			dispatch({
				type: types.OBSERVATIONS_CHECKLIST_FAILURE,
				payload: error.toString(),
			});
		}
	};
};

export const generateExcel = (
	projectName: string,
	data: ObservacionChecklist[]
): AppThunk => {
	return async (dispatch, getState) => {
		try {
			const user = getState().authReducer.user;
			const business =
				getState().businessReducer.selectedBusiness;

			if (!business)
				throw Error("No hay empresa seleccionada");
			if (!user)
				throw Error("El usuario no está autenticado.");
			dispatch({
				type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_LOADING,
			});
			const empresaSnap: firebase.firestore.DocumentSnapshot =
				await user.empresaReference.get();
			const empresa = empresaSnap.data();
			if (!empresa) {
				throw new Error("Error al cargar la empresa");
			}

			const response = await Axios.post(
				`${CF_URL}/generateSummaryExcel`,
				{
					dataRows: data,
					proyect: {
						Nombre: projectName,
						Empresa: business.Nombre,
					},
				},
				{
					responseType: "arraybuffer",
				}
			);
			downloadURI(
				window.URL.createObjectURL(
					new Blob([response.data])
				),
				`${projectName.replace(" ", "_")}_${format(
					new Date(),
					"dd_MM_yyyy_HH_mm_ss"
				)}.xlsx`
			);

			dispatch({
				type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_SUCCESS,
			});
		} catch (error: any) {
			dispatch({
				type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_FAILURE,
				payload: error.toString(),
			});
		}
	};
};

export const generateLegacyExcel = (
	projectId: string,
	filters: any = {},
	projectName?: string
): AppThunk => {
	return async (dispatch, getState) => {
		console.log("generateLegacyExcel started with:", { projectId, filters, projectName });
		try {
			const user = getState().authReducer.user;
			let business = getState().businessReducer.selectedBusiness;

			console.log("Redux state check:", { user: !!user, business: !!business });

			if (!user) {
				console.error("User not authenticated");
				throw Error("El usuario no está autenticado.");
			}

			// Si no hay business seleccionado, obtenerlo directamente del usuario
			if (!business && user.empresaReference) {
				console.log("Fetching business from user reference");
				const empresaSnap = await user.empresaReference.get();
				business = empresaSnap.data() as any;
				console.log("Business from user reference:", business);
			}

			if (!business) {
				console.error("No business available");
				throw Error("No hay empresa seleccionada");
			}

			dispatch({
				type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_LOADING,
			});
			console.log("Loading state dispatched");

			const empresaSnap: firebase.firestore.DocumentSnapshot =
				await user.empresaReference.get();
			const empresa = empresaSnap.data();
			console.log("Empresa data:", empresa);

			if (!empresa) {
				throw new Error("Error al cargar la empresa");
			}

			console.log("Making API call to legacy-excel-list");
			const response = await Axios.post(
				`${CF_URL}/projects/observations/legacy-excel-list`,
				{
					projectId,
					filters,
					nombreEmpresa: business.Nombre,
				},
				{
					responseType: "arraybuffer",
				}
			);

			const fileName = projectName
				? `${projectName.replace(" ", "_")}_${format(new Date(), "dd_MM_yyyy_HH_mm_ss")}.xlsx`
				: `observaciones_${format(new Date(), "dd_MM_yyyy_HH_mm_ss")}.xlsx`;

			downloadURI(
				window.URL.createObjectURL(
					new Blob([response.data])
				),
				fileName
			);

			dispatch({
				type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_SUCCESS,
			});
		} catch (error: any) {
			console.error("generateLegacyExcel error:", error);
			dispatch({
				type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_FAILURE,
				payload: error.toString(),
			});
		}
	};
};

export const generatePDF = (
	projectId: string,
	filteredObservations: ObservacionChecklist[],
	appliedFilters: any = {}
): AppThunk => {
	return async (dispatch, getState) => {
		const user = getState().authReducer.user;
		const business = getState().businessReducer.selectedBusiness;

		if (!business) throw Error("No hay empresa seleccionada");
		if (!user) throw Error("El usuario no está autenticado.");

		dispatch({
			type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_LOADING,
		});

		try {
			// Intentar con el endpoint específico para checklist observations PDF
			const response = await Axios.post(
				`${CF_URL}/projects/observations/checklist-summary-pdf`,
				{
					projectId: projectId,
					filters: appliedFilters,
					textoFooter: business.PiePagina || "CheckproSolutions",
					nombreEmpresa: business.Nombre,
				},
				{
					responseType: "arraybuffer",
				}
			);

			const fileName = `observaciones_${format(new Date(), "dd_MM_yyyy_HH_mm_ss")}.pdf`;
			
			downloadURI(
				window.URL.createObjectURL(
					new Blob([response.data], { type: 'application/pdf' })
				),
				fileName
			);

			dispatch({
				type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_SUCCESS,
			});
		} catch (error: any) {
			// Si el endpoint específico no funciona, intentar con el legacy
			try {
				console.log("Intentando con endpoint legacy...");
				const response = await Axios.post(
					`${CF_URL}/generateLegacyProjectSummary`,
					{
						textoFooter: business.PiePagina || "CheckproSolutions",
						proyectoId: projectId,
						userId: user.id || "",
						orderBy: "recinto",
						filters: appliedFilters
					}
				);

				if (!response.data?.url) throw Error("No data");

				window.open(response.data.url, "_blank");

				dispatch({
					type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_SUCCESS,
				});
			} catch (legacyError: any) {
				console.error("Error en ambos endpoints:", error, legacyError);
				dispatch({
					type: types.OBSERVATIONS_CHECKLIST_GENERATE_DOC_FAILURE,
					payload: legacyError.toString(),
				});
			}
		}
	};
};

function downloadURI(uri: string, name: string) {
	let link = document.createElement("a");
	link.download = name;
	link.href = uri;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}
